import { render, staticRenderFns } from "./InvoiceDeliveryButton.vue?vue&type=template&id=15f3b2ad&"
import script from "./InvoiceDeliveryButton.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDeliveryButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports